/* eslint-disable no-param-reassign */
const REVEAL_BREAKPOINT = '(min-width: 768px)';

function revealFooter(footer) {
  footer.classList.add('c-footer--ready');
  footer.style.removeProperty('visibility');
}

function initFooterScrollReveal(footer, content) {
  const revealQuery = window.matchMedia(REVEAL_BREAKPOINT);
  let slideRange = 0;
  let footerHeight = 0;
  let viewportHeight = 0;
  let ticking = false;
  let isActive = false;

  function measure() {
    viewportHeight = window.innerHeight;
    footerHeight = footer.offsetHeight;
    slideRange = Math.max(0, footerHeight - viewportHeight);
    footer.style.setProperty('--footer-height', `${footerHeight}px`);
  }

  function updateTransform() {
    ticking = false;

    if (!isActive || slideRange <= 0) {
      content.style.transform = '';
      return;
    }

    const footerTop = footer.getBoundingClientRect().top;
    const progress = Math.min(1, Math.max(0, (viewportHeight - footerTop) / footerHeight));
    const offset = (1 - progress) * slideRange;

    content.style.transform = offset > 0.5 ? `translate3d(0, ${offset}px, 0)` : '';
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateTransform);
    }
  }

  function remeasure() {
    if (!isActive) {
      return;
    }

    measure();
    requestUpdate();
  }

  function enable() {
    isActive = true;
    footer.classList.add('c-footer--js-reveal');
    measure();
    updateTransform();
  }

  function disable() {
    isActive = false;
    footer.classList.remove('c-footer--js-reveal');
    content.style.transform = '';
    footer.style.removeProperty('--footer-height');
  }

  function handleBreakpoint(event) {
    if (event.matches) {
      enable();
    } else {
      disable();
    }
  }

  handleBreakpoint(revealQuery);
  revealQuery.addEventListener('change', handleBreakpoint);

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', remeasure);

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(remeasure);
    observer.observe(footer);
  }
}

function initFooterReveal() {
  const footer = document.querySelector('.c-footer');
  const content = footer?.querySelector('.c-footer__content');

  if (!footer || !content) {
    return;
  }

  const start = () => {
    revealFooter(footer);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    initFooterScrollReveal(footer, content);
  };

  if (document.readyState === 'complete') {
    start();
    return;
  }

  window.addEventListener('load', start, { once: true });
}

export default initFooterReveal;
